import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ExportacaoAgenteFiananceiroRoutingModule } from './exportacao-agente-financeiro-routing.module';
import { AcompMetasDistribuicaoLimitesComponent } from './acomp-metas-distribuicao-limites/acomp-metas-distribuicao-limites.component';
import { SharedModule } from 'src/app/shared/shared.module';



@NgModule({
  declarations: [AcompMetasDistribuicaoLimitesComponent],
  imports: [
    SharedModule,
    CommonModule,
    ExportacaoAgenteFiananceiroRoutingModule
  ],
  providers: [
    DatePipe
  ]
})
export class ExportacaoAgenteFinanceiroModule { }
